@if(visibleSoloNuevo == false){
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-row">
        <div class="a-w1 a-w1-row">
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="numeroplaca" type="text" pInputText class="w-full md:w-56"
                        [maxlength]="11" />
                    <label for="on_label">N° Placa</label>
                </p-floatlabel>
            </div>
            <div style="display: flex; gap: 20px;">
                <p-button icon="pi pi-search" label="Buscar" (onClick)="buscar()"></p-button>
                <p-button icon="pi pi-plus" label="Nuevo" (onClick)="nuevo()"></p-button>
                <p-button icon="pi pi-file-excel" label="Importar" (onClick)="importExcel()"></p-button>
                <p-button icon="pi pi-file-excel" label="Exportar Formato" (onClick)="exportExcel()"></p-button>
            </div>
        </div>
    </form>
</div>
<app-datatable [metadataTable]="metadataTable" [dataTable]="dataTable" [filterGlobal]="true">
    <ng-template #addHeaderStart>
        <th class="header">
            <div class="items-header">
                <span>Acción</span>
            </div>
        </th>
    </ng-template>
    <ng-template #addBodyStart let-row="row">
        <td class="a-datatable-datos-body-accion row-space">
            <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="editCarreta(row)" pTooltip="Editar" tooltipPosition="top"
                [disabled]="row.spcR_Activo === true ? false: true"></p-button>
            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-warn p-button-outlined"
                (onClick)="TransaccionCarreta('D',row)" pTooltip="Desactivar" tooltipPosition="top"
                [disabled]="row.spcR_Activo === true ? false: true"></p-button>
            <p-button [icon]="row.spcR_Activo === true && row.spcR_Bloqueado === true? 'pi pi-eye':'pi pi-lock'"
                styleClass="p-button-rounded p-button-danger p-button-outlined" (onClick)="abrirObservaciones(row)"
                [pTooltip]="row.spcR_Activo === true && row.spcR_Bloqueado === true? 'Ver Observaciones': 'Bloquear'"
                tooltipPosition="top"></p-button>
            <p-button icon="pi pi-lock-open" styleClass="p-button-rounded p-button-success p-button-outlined"
                (onClick)="desbloquear(row)" pTooltip="Desbloquear" tooltipPosition="top"
                *ngIf="row.spcR_Activo === true && row.spcR_Bloqueado === true ? true : false"></p-button>
        </td>
    </ng-template>
</app-datatable>
}
<p-dialog header="Mantenimiento Carreta" [(visible)]="visible" [style]="{width: '40vw',height: '30vh'}" appendTo="body" [closable]="false">
    <br />
    <div class="a-example-full-width-alterno-content">
        <p-toast></p-toast>
        <form [formGroup]="groupPoppup" class="a-w1" style="margin: 0;">
            <div class="a-w1-row" style="padding-top: 5px;">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <input formControlName="numeroplaca" type="text" pInputText class="w-full md:w-56"
                            [maxlength]="11"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('numeroplaca')?.invalid && (this.groupPoppup.get('numeroplaca')?.touched)}" />
                        <label for="on_label">Número de Placa</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('numeroplaca')?.invalid && (this.groupPoppup.get('numeroplaca')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <!-- <div class="a-w1-row" style="padding-top: 20px;">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <textarea pTextarea rows="5" cols="30" formControlName="observacion" style="width: 100%;" class="w-full md:w-56"></textarea>
                    <label for="on_label">Observación</label>
                </p-floatlabel>
            </div> -->
            <!-- <div class="a-w1-row" style="padding-top: 20px;">
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <p-select [options]="listEmpresa" placeholder="‎ " optionLabel="nombre"
                            formControlName="empresa" optionValue="codigo" appendTo="body" class="w-full md:w-56">
                        </p-select>
                        <label for="on_label">Empresa</label>
                    </p-floatLabel>
                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <p-select [options]="listSucursal" placeholder="‎ " optionLabel="nombre"
                            formControlName="sucursal" optionValue="codigo" appendTo="body" class="w-full md:w-56">
                        </p-select>
                        <label for="on_label">Sucursal</label>
                    </p-floatLabel>
                </div>
            </div> -->
        </form>
    </div>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button *ngIf="visiblebtn" label="Guardar" (onClick)="TransaccionCarreta('I', 0)"></p-button>
        <p-button *ngIf="!visiblebtn" label="Actualizar" (onClick)="TransaccionCarreta('U', 0)"></p-button>
        <p-button label="Salir" (onClick)="salir()"></p-button>
    </div>
</p-dialog>
<p-dialog header="" [(visible)]="visibleImport" [style]="{width: '50vw',height: '70vh'}">
    <br>
    <p-toast key="toast1" />
    <div fxLayoutGap="20px" class="a-w1" style="display: flex; justify-content: center;">
        <input type="file" (change)="onFileChange($event)" id="fileInput" #fileInput style="display: none" />
        <p-button icon="pi pi-file-excel" label="Cargar Excel" severity="info" (onClick)="selectFile()"></p-button>
        <p-button icon="pi pi-save" label="Guardar Excel" severity="info" [disabled]="disabledSave"
            (onClick)="guardarExcel()"></p-button>
        <p-button icon="pi pi-sign-out" label="Salir" severity="info" (onClick)="salirImportar()"></p-button>
    </div>
    <div style="padding-top: 30px;">
        <app-datatable [dataTable]="dataTableImport" [metadataTable]="metadataTableImport" [scrollHeight]="'600px'">
            <ng-template #addHeaderStart>
                <th class="header">
                    <div class="items-header">
                        <span></span>
                    </div>
                </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
                <td class="a-datatable-datos-body-accion row-space">
                    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-outlined"
                        (onClick)="deleteRow(row)" pTooltip="Eliminar" tooltipPosition="top"
                        [disabled]="row.conObservacion === true ? false: true"></p-button>
                </td>
            </ng-template>
        </app-datatable>
    </div>
</p-dialog>
<p-dialog header="" [(visible)]="visibleObsr" [style]="{width: '40vw',height: '45vh'}" appendTo="body">
    <div class="a-example-full-width-alterno-content">
        <form [formGroup]="groupPoppupObs" class="a-w1" style="margin: 0;">
            <div class="a-w1-row" style="padding-top: 5px;">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select [options]="ListaTodosTipoBlo" placeholder="‎ " optionLabel="nombre"
                            formControlName="tipobloqueo" optionValue="codigo" appendTo="body"
                            styleClass="w-full md:w-56" [readonly]="verObsr"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppupObs.get('tipobloqueo')?.invalid && (this.groupPoppupObs.get('tipobloqueo')?.touched)}">
                        </p-select>
                        <label for="on_label">Tipo Bloqueo</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppupObs.get('tipobloqueo')?.invalid && (this.groupPoppupObs.get('tipobloqueo')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <textarea pTextarea rows="5" cols="30" formControlName="observaciones" style="width: 100%;"
                            class="w-full md:w-56" [readOnly]="verObsr"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppupObs.get('observaciones')?.invalid && (this.groupPoppupObs.get('observaciones')?.touched)}"></textarea>
                        <label for="on_label">Observaciones</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppupObs.get('observaciones')?.invalid && (this.groupPoppupObs.get('observaciones')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
        </form>
    </div>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button label="Guardar" *ngIf="verObsr===true?false:true" (onClick)="TransaccionCarreta('B', 0)"></p-button>
        <p-button label="Salir" *ngIf="verObsr===true?false:true" (onClick)="salirBloqueo()"></p-button>
    </div>
</p-dialog>